import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Header from '../../components/headers/MainHeader';
import Footer from "../../components/footers/MainFooterWithLinks";
import Buy from "../../images/icon/HowToBuyAbroad.svg";
import Choose from "../../images/icon/GoodChoose.svg";
import Purchase from "../../images/icon/PurchaseGood.svg";
import Delivery from "../../images/icon/DeliveryIcon.svg";
import AnimationRevealPage from "../../components/helpers/AnimationRevealPage";
import DesignIllustration from "../../images/img/Как покупать товары из-за границы.png";
import { SectionHeading } from "../../components/misc/Headings";
import { useTranslation } from "react-i18next";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-12 lg:py-16`;
const HeadingColumn = tw.div`text-center xl:text-left max-w-lg xl:max-w-none mx-auto xl:mx-0 flex flex-col items-center xl:items-start`;

const HeadingTitle = tw(SectionHeading)`
  text-3xl md:text-2xl lg:text-4xl xl:text-3xl leading-tight
  mb-5 text-secondary-600 flex items-center
`;

const GreenLink = styled.a`${tw`text-green-500`} text-decoration: none;`;
const HeadingDescription = styled.p`${tw`text-lg font-medium text-secondary-600`} line-height: 32px; margin-top: 12px;`;
const SectionContainer = styled.div`${tw`py-8 px-4 lg:px-8 mb-8 bg-gray-100 rounded-lg`}`;
const IconTitleContainer = styled.div`${tw`flex items-center mb-4`}`;
const BuyIcon = styled.img`${tw`mr-4`}`;

export default function HowToBuyAbroadPage() {
    const { t } = useTranslation();

    return (
        <AnimationRevealPage>
            <Header
                heading={t("howToBuy.header.title")}
                paragraph={t("howToBuy.header.paragraph")}
                imageSrc={DesignIllustration}
                roundedHeaderButton={false}
            />

            <Container>
                <Content>
                    {/* Блок 1 */}
                    <SectionContainer>
                        <HeadingColumn>
                            <IconTitleContainer>
                                <HeadingTitle>
                                    <BuyIcon src={Buy} alt="How to Buy Abroad" />
                                    {t("howToBuy.buyAbroad.title")}
                                </HeadingTitle>
                            </IconTitleContainer>
                            <HeadingDescription>
                                {t("howToBuy.buyAbroad.text")}
                            </HeadingDescription>
                        </HeadingColumn>
                    </SectionContainer>

                    {/* Блок 2 */}
                    <SectionContainer>
                        <IconTitleContainer>
                            <BuyIcon src={Choose} alt="Choose Product" />
                            <HeadingTitle>{t("howToBuy.choose.title")}</HeadingTitle>
                        </IconTitleContainer>
                        <HeadingDescription>
                            {t("howToBuy.choose.text.part1")}{" "}
                            <GreenLink href="#">{t("howToBuy.choose.linkText")}</GreenLink>.
                        </HeadingDescription>
                    </SectionContainer>

                    {/* Блок 3 */}
                    <SectionContainer>
                        <IconTitleContainer>
                            <BuyIcon src={Purchase} alt="Purchase Product" />
                            <HeadingTitle>{t("howToBuy.payment.title")}</HeadingTitle>
                        </IconTitleContainer>
                        <HeadingDescription>
                            {t("howToBuy.payment.text.part1")}{" "}
                            <GreenLink href="#">{t("howToBuy.payment.linkText")}</GreenLink>.
                        </HeadingDescription>
                    </SectionContainer>

                    {/* Блок 4 */}
                    <SectionContainer>
                        <IconTitleContainer>
                            <BuyIcon src={Delivery} alt="Product Delivery" />
                            <HeadingTitle>{t("howToBuy.delivery.title")}</HeadingTitle>
                        </IconTitleContainer>
                        <HeadingDescription>
                            {t("howToBuy.delivery.text")}
                        </HeadingDescription>
                    </SectionContainer>
                </Content>
            </Container>

            <Footer />
        </AnimationRevealPage>
    );
}
